import React from 'react';
import EditableDropDown from '../../../components/common/EditableDropdown';
import Creatable from 'react-select/creatable';
import { Button, Form, FormControl } from '@themesberg/react-bootstrap';
import { ErrorMessage } from '../../scheme-management/Components/StyledComponents';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheck,
  faEye,
  faFile,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';
import { arrayToDropdownOptions } from '../../../utils/sms/arrayToDropdownOptions';
import ActionButtonWithIcons from '../../../components/common/ActionButtonWithIcons';
import { hasRole } from '../../../utils/roles';
import { rolesConstants } from '../../../constants/roles';
import { getTableRowCheckBox } from '../../../utils/table';
import {
  returnUserReadableDateTime,
  returnUserReadableLocalDateTime,
} from '../../../utils/datetime';
import ScheduleFormatter from './components/ScheduleFormatter';
import {
  validatePrebookPrice,
  validateVsPrice,
} from './components/validations';
import StatusCard from '../interBranchTransfers/StatusCard';

export const pricingTemplateMappings = {
  sku: 'sku',
  mrp: 'mrp',
  vsp: 'vsp',
  OFFER_PRICE: 'offer_price',
  OFFER_PRICE_START_DATETIME: 'offer_price_start_datetime',
  OFFER_PRICE_END_DATETIME: 'offer_price_end_datetime',
  IS_PREBOOK_PRODUCT: 'is_prebook_product',
  IS_PREBOOK_PARTIAL_PAYMENT: 'is_prebook_partial_payment',
  PREBOOK_PRICE: 'prebook_price',
  PREBOOK_LAUNCH_DATE: 'prebook_launch_date',
  PREBOOK_END_DATE: 'prebook_end_date',
  PRIMARY_SKU: 'primary_sku',
  PRIMARY_SKU_PRICE: 'primary_sku_price',
  FREEBIES_SKU: 'freebies_sku',
  FREEBIES_START_DATETIME: 'freebies_start_datetime',
  FREEBIES_END_DATETIME: 'freebies_end_datetime',
  COMBI_SKU_1: 'combi_sku_1',
  COMBI_SKU_PRICE_1: 'combi_sku_price_1',
  COMBI_SKU_2: 'combi_sku_2',
  COMBI_SKU_PRICE_2: 'combi_sku_price_2',
  COMBI_SKU_3: 'combi_sku_3',
  COMBI_SKU_PRICE_3: 'combi_sku_price_3',
  COMBI_SKU_4: 'combi_sku_4',
  COMBI_SKU_PRICE_4: 'combi_sku_price_4',
  COMBI_SKU_5: 'combi_sku_5',
  COMBI_SKU_PRICE_5: 'combi_sku_price_5',
  COMBINED_PRICE: 'combined_price',
  COMBI_START_DATETIME: 'Combi_start_datetime',
  COMBI_END_DATETIME: 'Combi_end_datetime',
};

export const pricingChoices = {
  VSP: 'VSP',
  OFFER_PRICE: 'Offer price',
  PREBOOK_PRICE: 'PreBook Price',
  // FREEBIE: 'Freebie',
  COMBI: 'Combi',
};

export function getPriceField(each) {
  if (!each) return '';
  switch (each.choose) {
    case pricingChoices.VSP:
      return 'vs_price';
    case pricingChoices.PREBOOK_PRICE:
      return pricingTemplateMappings.PREBOOK_PRICE;
    case pricingChoices.OFFER_PRICE:
      return pricingTemplateMappings.OFFER_PRICE;
    case pricingChoices.FREEBIE:
      return pricingTemplateMappings.FREEBIE_PRICE;
    case pricingChoices.COMBI:
      return pricingTemplateMappings.COMBINED_PRICE;
    default:
      return null;
  }
}

export function getDatesField(choose) {
  if (!choose) return null;
  switch (choose) {
    case pricingChoices.PREBOOK_PRICE:
      return 'prebookDates';
    case pricingChoices.OFFER_PRICE:
      return 'offerPriceDates';
    case pricingChoices.COMBI:
      return 'combiDates';
    default:
      return null;
  }
}

export function getDateFieldsBasedOnChoose(choose) {
  switch (choose) {
    case pricingChoices.PREBOOK_PRICE:
      return ['prebook_launch_date', 'prebook_end_date'];
    case pricingChoices.OFFER_PRICE:
      return ['offer_price_start_datetime', 'offer_price_end_datetime'];
    case pricingChoices.COMBI:
      return ['combi_start_datetime', 'combi_end_datetime'];
    default:
      return null;
  }
}

export const productPriceColumns = (handleChange, handleXClick, values) => {
  const columns = [
    {
      dataField: 'productTitle',
      text: 'Product Name',
      headerClasses: 'rounded-0 p-3 h-auto',
      formatter: (cell, row) => {
        return (
          <div
            className="d-block"
            style={{ width: '16.25rem', whiteSpace: 'wrap' }}
          >
            {cell}
          </div>
        );
      },
    },
    {
      dataField: 'vanNo',
      text: 'Van No.',
      // key: true,
    },
    {
      dataField: 'vsp',
      text: 'current price',
    },
    {
      dataField: 'setPrice',
      text: 'price limit',
    },
    {
      dataField: 'requestedPrice',
      text: 'new price',
      style: { maxWidth: '7.5rem' },
      formatter: (cell, row) => {
        console.log(values[row?.vanNo]?.requestedPrice);
        return (
          <Form.Control
            width={'100%'}
            type="number"
            height={'1.7rem'}
            id={row?.vanNo}
            placeholder={'please enter value'}
            // value={values[row?.vanNo]?.requestedPrice}
            value={cell}
            onChange={(e) =>
              handleChange(e?.target?.value, 'requestedPrice', row?.vanNo)
            }
          />
        );
      },
    },
    {
      dataField: 'requestedReason',
      text: 'Price change reason',
      formatter: (cell, row) => {
        const options = [
          'Price Match Competitor',
          'Seasonal Discount',
          'Promotional Offer',
          'Market Change',
        ];
        // const selectedOption = values[row?.vanNo]?.requestedReason
        //   ? {
        //       label: values[row?.vanNo]?.requestedReason,
        //       value: values[row?.vanNo]?.requestedReason,
        //     }
        //   : null;
        // console.log(values[row?.vanNo]?.requestedReason);
        return (
          <Form.Group>
            <Creatable
              // value={values[row?.vanNo]?.requestedReason}
              value={cell}
              onChange={(option) =>
                handleChange(option?.value, 'requestedReason', row?.vanNo)
              }
              id={row?.vanNo}
              options={arrayToDropdownOptions(options)}
              placeholder="Select Or Type the Reason"
            />
          </Form.Group>
        );
      },
    },
    {
      dataField: 'delete',
      text: '',
      formatter: (cell, row) => {
        return (
          <Button
            onClick={(e) => {
              e.stopPropagation();
              handleXClick(row?.vanNo);
            }}
            //   variant="white"
            className="d-flex bg-white justify-content-center align-content-center"
            style={{
              height: '100%',
              margin: '0',
              padding: '0',
              borderColor: 'white',
            }}
          >
            <FontAwesomeIcon icon={faXmark} size="xl" color="black" />
          </Button>
        );
      },
    },
  ];
  return columns;
};

export const allOptions = {
  view: 'View Details',
  accept: 'Accept Request',
  reject: 'Reject Request',
  resubmit: 'Resubmit',
};

export const actionOptions = {
  ['pending']: [
    { icon: faEye, label: allOptions.view },
    { icon: faCheck, label: allOptions.accept },
    { icon: faXmark, label: allOptions.reject },
  ],
  ['approved']: [{ icon: faEye, label: allOptions.view }],
  ['rejected']: [
    { icon: faEye, label: allOptions.view },
    // { icon: faFile, label: allOptions.resubmit },
  ],
};

export const getPricingStatusColors = (status = '') => {
  const result = {
    bgColor: '',
    color: '',
  };
  switch (status?.toLowerCase()) {
    case 'review':
      result.bgColor = 'rgba(236, 249, 253, 1)';
      result.color = 'rgba(9, 72, 179, 1)';
      break;

    case 'rejected':
      result.bgColor = '#FDDDDD';
      result.color = 'red';
      break;

    case 'pending':
      result.bgColor = '#FDEDD9';
      result.color = '#F4921B';
      break;
    case 'approved':
      result.bgColor = 'rgba(212, 247, 232, 1)';
      result.color = 'rgba(33, 168, 113, 1)';
      break;
    case 'submitted':
      result.bgColor = '#FDEDD9';
      result.color = '#F4921B';
      break;
    case 'success':
      result.bgColor = 'rgba(212, 247, 232, 1)';
      result.color = 'rgba(33, 168, 113, 1)';
      break;
    case 'skipped':
      result.bgColor = '#FDDDDD';
      result.color = 'red';
      break;
    default:
      result.bgColor = 'rgba(242, 230, 255, 1)';
      result.color = 'rgba(33, 168, 113, 1)';
      break;
  }
  return result;
};

export const pricingListColumns = (
  pageType,
  onActionClick,
  roles = [],
  onRowSelect = null,
  onSelectAll = null
) => {
  const columns = [
    {
      dataField: 'productTitle',
      text: 'Product Name',
      headerClasses: 'rounded-0 p-3 h-auto',
      formatter: (cell, row) => {
        return (
          <div
            className="d-block"
            style={{ width: '16.25rem', whiteSpace: 'wrap' }}
          >
            {cell}
          </div>
        );
      },
    },
    {
      dataField: 'vanNo',
      text: 'Van No.',
      style: { textAlign: 'center' },
      // key: true,
    },
    {
      dataField: 'vsp',
      text: 'vsp',
      formatter: (cell, row) => {
        return <div>{Math.floor(cell).toFixed(2)}</div>;
      },
    },
    {
      dataField: 'vs_price',
      text: 'vs_price',
      formatter: (cell, row) => {
        return <div>{Math.floor(cell).toFixed(2)}</div>;
      },
    },
    {
      dataField: 'prebookDates',
      text: 'PrebookDetails',
      formatter: (cell, row) => {
        if (row?.choose !== pricingChoices.PREBOOK_PRICE) return '-';
        const schedule = cell ? cell : {};
        return (
          <div
            style={{
              width: '15rem',
              whiteSpace: 'wrap',
            }}
          >
            {/* <div>is_prebook_product: {row?.is_prebook_product}</div> */}
            <div>
              Partial_payment:{' '}
              {row[pricingTemplateMappings.IS_PREBOOK_PARTIAL_PAYMENT]}
            </div>
            <div>
              prebook_price: {row[pricingTemplateMappings.PREBOOK_PRICE]}
            </div>
            <div>{schedule?.desc || '-'}</div>
            {/* <div>
              launch_date:{row[pricingTemplateMappings.PREBOOK_LAUNCH_DATE]} */}
            {/* {returnUserReadableLocalDateTime(row?.prebook_launch_date?.iso)} */}
            {/* </div>
            <div>
              end_date:{row[pricingTemplateMappings.PREBOOK_END_DATE]} */}
            {/* {returnUserReadableLocalDateTime(row?.prebook_end_date?.iso)} */}
            {/* </div> */}
          </div>
        );
      },
    },
    {
      dataField: 'offerPriceDates',
      text: 'offerDetails',
      formatter: (cell, row) => {
        if (row?.choose !== pricingChoices.OFFER_PRICE) return '-';
        const schedule = cell ? cell : {};
        return (
          <div
            style={{
              width: '15rem',
              whiteSpace: 'wrap',
            }}
          >
            <div> offer_price: {row[pricingTemplateMappings.OFFER_PRICE]}</div>
            <div>{schedule?.desc || '-'}</div>
            {/* <div>
              start_datetime:
              {row[pricingTemplateMappings.OFFER_PRICE_START_DATETIME]} */}
            {/* {returnUserReadableLocalDateTime(
                row?.offer_price_start_datetime?.iso
              )} */}
            {/* </div>
            <div>
              end_datetime:
              {returnUserReadableLocalDateTime(
                row?.offer_price_end_datetime?.iso
              )}
            </div> */}
          </div>
        );
      },
    },
    // {
    //   dataField: 'Combo_primary_sku_1',
    //   text: 'combiDetails1',
    //   formatter: (cell, row) => {
    //     if (row?.choose !== 'Combi') return '-';
    //     return (
    //       <div>
    //         <div>
    //           primary_sku_1: {row[pricingTemplateMappings.COMBO_PRIMARY_SKU_1]}
    //         </div>
    //         {/* <div>ERP_Combo_sku_1: {row?.Combo_ERP_Combo_sku_1}</div> */}
    //         <div> price_1: {row[pricingTemplateMappings.COMBO_PRICE_1]}</div>
    //         {/* <div>
    //           start_datetime_1:
    //           {returnUserReadableLocalDateTime(
    //             row?.Combo_start_datetime_1?.iso
    //           )}
    //         </div>
    //         <div>
    //           end_datetime_1:
    //           {returnUserReadableLocalDateTime(row?.Combo_end_datetime_1?.iso)}
    //         </div> */}
    //       </div>
    //     );
    //   },
    // },
    // {
    //   dataField: 'Combo_primary_sku_2',
    //   text: 'combiDetails2',
    //   formatter: (cell, row) => {
    //     if (row?.choose !== 'Combi') return '-';
    //     return (
    //       <div>
    //         <div>
    //           primary_sku_2: {row[pricingTemplateMappings.COMBO_PRIMARY_SKU_2]}
    //         </div>
    //         {/* <div>ERP_Combo_sku_2: {row?.Combo_ERP_Combo_sku_2}</div> */}
    //         <div>price_2: {row[pricingTemplateMappings.COMBI_SKU_PRICE_2]}</div>
    //         {/* <div>
    //           start_datetime_2:{' '}
    //           {returnUserReadableLocalDateTime(
    //             row?.Combo_start_datetime_2?.iso
    //           )}
    //         </div>
    //         <div>
    //           end_datetime_2:{' '}
    //           {returnUserReadableLocalDateTime(row?.Combo_end_datetime_2?.iso)}
    //         </div> */}
    //       </div>
    //     );
    //   },
    // },
    // {
    //   dataField: 'Combo_primary_sku_3',
    //   text: 'combiDetails3',
    //   formatter: (cell, row) => {
    //     if (row?.choose !== 'Combi') return '-';
    //     return (
    //       <div>
    //         <div>
    //           primary_sku_3: {row[pricingTemplateMappings.COMBO_PRIMARY_SKU_3]}
    //         </div>
    //         {/* <div>ERP_Combo_sku_3: {row[pricingTemplateMappings.COMBI_SKU_PRICE_3]}</div>{' '} */}
    //         <div>price_3: {row[pricingTemplateMappings.COMBI_SKU_PRICE_3]}</div>
    //         {/* <div>
    //           start_datetime_3:{' '}
    //           {returnUserReadableLocalDateTime(
    //             row?.Combo_start_datetime_3?.iso
    //           )}
    //         </div>
    //         <div>
    //           end_datetime_3:{' '}
    //           {returnUserReadableLocalDateTime(row?.Combo_end_datetime_3?.iso)}
    //         </div> */}
    //       </div>
    //     );
    //   },
    // },
    // {
    //   dataField: 'Combo_primary_sku_4',
    //   text: 'combiDetails4',
    //   formatter: (cell, row) => {
    //     if (row?.choose !== 'Combi') return '-';
    //     return (
    //       <div>
    //         <div>primary_sku_4: {row[pricingTemplateMappings.COMBI_SKU_4]}</div>
    //         {/* <div>ERP_Combo_sku_4: {row?.Combo_ERP_Combo_sku_4}</div>{' '} */}
    //         <div>price_4: {row[pricingTemplateMappings.COMBI_SKU_PRICE_4]}</div>
    //         {/* <div>
    //           start_datetime_4:{' '}
    //           {returnUserReadableLocalDateTime(
    //             row?.Combo_start_datetime_4?.iso
    //           )}
    //         </div>
    //         <div>
    //           end_datetime_4:{' '}
    //           {returnUserReadableLocalDateTime(row?.Combo_end_datetime_4?.iso)}
    //         </div> */}
    //       </div>
    //     );
    //   },
    // },
    // {
    //   dataField: 'Combo_primary_sku_5',
    //   text: 'combiDetails5',
    //   formatter: (cell, row) => {
    //     if (row?.choose !== 'Combi') return '-';
    //     return (
    //       <div>
    //         <div>primary_sku_5: {row[pricingTemplateMappings.COMBI_SKU_5]}</div>
    //         {/* <div>ERP_Combo_sku_5: {row?.Combo_ERP_Combo_sku_5}</div>{' '} */}
    //         <div>price_5: {row[pricingTemplateMappings.COMBI_SKU_PRICE_5]}</div>
    //         {/* <div>
    //           start_datetime_5:{' '}
    //           {returnUserReadableLocalDateTime(
    //             row?.Combo_start_datetime_5?.iso
    //           )}
    //         </div>
    //         <div>
    //           end_datetime_5:{' '}
    //           {returnUserReadableLocalDateTime(row?.Combo_end_datetime_5?.iso)}
    //         </div> */}
    //       </div>
    //     );
    //   },
    // },
    {
      dataField: 'combiDates',
      text: 'Combi Details',
      formatter: (cell, row) => {
        if (row?.choose !== pricingChoices.COMBI) return '-';
        const schedule = cell ? cell : {};
        return (
          <div
            style={{
              width: '15rem',
              whiteSpace: 'wrap',
            }}
          >
            <div>
              Combined Price: {row[pricingTemplateMappings.COMBI_PRICE]}
            </div>
            <div>{schedule?.desc || '-'}</div>
            {/* <div>ERP_Combo_sku_1: {row?.freebies_ERP_Combo_sku_1}</div>
            <div>
              start_datetime_1:
              {returnUserReadableLocalDateTime(
                row?.freebies_start_datetime_1?.iso
              )}
            </div>
            <div>
              end_datetime_1:
              {returnUserReadableLocalDateTime(
                row?.freebies_end_datetime_1?.iso
              )}
            </div> */}
          </div>
        );
      },
    },
    // {
    //   dataField: 'freebieDates',
    //   text: 'freebieDetails',
    //   formatter: (cell, row) => {
    //     if (row?.choose !== 'Freebie') return '-';
    //     const schedule = cell ? cell : {};
    //     return (
    //       <div
    //         style={{
    //           width: '15rem',
    //           whiteSpace: 'wrap',
    //         }}
    //       >
    //         <div>primary_sku_1: {row[pricingTemplateMappings.PRIMARY_SKU]}</div>
    //         <div>
    //           primary_sku_price_1:
    //           {row[pricingTemplateMappings.PRIMARY_SKU_PRICE]}
    //         </div>
    //         <div>freebie_sku:{row[pricingTemplateMappings.FREEBIES_SKU]}</div>
    //         <div>{schedule?.desc || '-'}</div>
    //         {/* <div>primary_sku_price_1:{row[pricingTemplateMappings.PRIMARY_SKU_PRICE]}</div> */}
    //         {/* <div>
    //           start_datetime_1:
    //           {returnUserReadableLocalDateTime(
    //             row?.freebies_start_datetime_1?.iso
    //           )}
    //         </div>
    //         <div>
    //           end_datetime_1:
    //           {returnUserReadableLocalDateTime(
    //             row?.freebies_end_datetime_1?.iso
    //           )}
    //         </div> */}
    //       </div>
    //     );
    //   },
    // },
    // {
    //   dataField: 'requestedOfferPrice',
    //   text: 'Requested Offer price',
    // },
    {
      dataField: 'status',
      text: 'Status',
      formatter: (cell) => {
        return (
          <StatusCard
            status={cell}
            bgColor={getPricingStatusColors(cell).bgColor || ''}
            color={getPricingStatusColors(cell).color || ''}
            minWidth={'7em'}
            height={'2.4rem'}
          />
        );
      },
    },
    {
      dataField: 'dateSubmitted',
      text: 'Date Submitted',
      formatter: (cell, row) => {
        return <div>{returnUserReadableDateTime(cell?.iso)}</div>;
      },
    },
    {
      dataField: 'action',
      text: 'Action',
      headerClasses: 'rounded-0 p-3 h-auto',
      style: { textAlign: 'center' },
      formatter: (cell, row) => {
        let options = actionOptions[pageType];
        if (
          !hasRole(roles, [rolesConstants.ADMIN, rolesConstants.SUPER_ADMIN])
        ) {
          options = options.filter(
            (option) => option.label !== 'Accept Request'
          );
        }
        return (
          <ActionButtonWithIcons
            options={options}
            onActionClick={(option) => onActionClick(option, row?.objectId)}
          />
        );
      },
    },
  ];

  if (hasRole(roles, [rolesConstants.ADMIN, rolesConstants.SUPER_ADMIN])) {
    columns.splice(0, 0, {
      dataField: 'objectId',
      text: 'select',
      headerFormatter: (column, colIndex, components) => {
        return (
          <div className="d-flex flex-column align-items-center">
            {/* <span className="mb-2">Select All</span> */}
            <Form.Check
              type="checkbox"
              // className="custom-checkbox"
              style={{ transform: 'scale(1.4)', cursor: 'pointer' }}
              onChange={(e) => onSelectAll(e.target.checked)}
            />
          </div>
        );
      },
      formatter: (cell, row) => {
        return getTableRowCheckBox(onRowSelect, cell, row?.isSelected, false);
      },
    });
  }
  return columns;
};

// const scheduleColumn = {
//   dataField: 'schedule', // Replace with your actual field name
//   text: 'Schedule',
//   formatter: (cell, row) => {
//     const [showModal, setShowModal] = useState(false);

//     return (
//       <>
//         <Button
//           variant="link"
//           onClick={() => setShowModal(true)}
//           style={{ padding: 0, textDecoration: 'none' }}
//         >
//           {cell ? formatScheduleSummary(cell) : 'Set Schedule'}
//         </Button>
//         <ScheduleModal
//           show={showModal}
//           onHide={() => setShowModal(false)}
//           initialValue={cell || {}}
//           onSave={(newSchedule) => {
//             // Update the row with the new schedule
//             // Example: updateRow(row, 'schedule', newSchedule);
//             setShowModal(false);
//           }}
//           title="Edit Schedule"
//         />
//       </>
//     );
//   },
// };

export const getCreateRequestColumns = (
  setProducts,
  setCopyData,
  errors,
  setFieldError,
  focusRowId,
  setFocusRowId,
  createRowChangeHandler,
  handleXClick
) => [
  {
    dataField: 'productTitle',
    text: 'Product Name',
    headerClasses: 'rounded-0 p-3 h-auto',
    formatter: (cell) => (
      <div
        className="d-block"
        style={{ width: '10.25rem', whiteSpace: 'wrap' }}
      >
        {cell}
      </div>
    ),
  },
  {
    dataField: 'vanNo',
    text: 'Van No.',
  },
  {
    dataField: 'vsp',
    text: 'vsp',
    formatter: (cell) => <div>{Number(cell)}</div>,
  },
  {
    dataField: 'mrp',
    text: 'MRP',
    formatter: (cell) => <div>{Number(cell)}</div>,
  },
  {
    dataField: 'choose',
    text: 'option',
    formatter: (cell, row) => {
      // const options = [
      //   'Offer price',
      //   'VSP',
      //   'PreBook Price',
      //   'Freebie',
      //   'Combi',
      // ];
      const options = Object.values(pricingChoices);
      console.log(errors, row, cell, row?.objectId, errors[row?.objectId]);
      return (
        <div>
          <EditableDropDown
            id={row?.objectId}
            onChange={(option) => {
              const newChoose = option?.value || '';
              createRowChangeHandler(
                setProducts,
                setCopyData,
                'choose'
              )(row, newChoose);
              setFieldError(row.objectId, 'choose', '');
              [
                pricingTemplateMappings.OFFER_PRICE,
                pricingTemplateMappings.PREBOOK_PRICE,
                pricingTemplateMappings.COMBINED_PRICE,
                pricingTemplateMappings.IS_PREBOOK_PARTIAL_PAYMENT,
                pricingTemplateMappings.IS_PREBOOK_PRODUCT,
                // 'vs_price',
              ].forEach((key) => {
                createRowChangeHandler(setProducts, setCopyData, key)(row, '');
                setFieldError(row?.objectId, key, '');
              });

              ['offerPriceDates', 'prebookDates', 'combiDates'].forEach(
                (key) => {
                  createRowChangeHandler(
                    setProducts,
                    setCopyData,
                    key
                  )(row, {});
                  setFieldError(row?.objectId, key, '');
                }
              );

              // setTimeout(() => {
              //   // let React flush DOM first
              //   const current = row;
              //   const priceKey =
              //     newChoose === pricingChoices.OFFER_PRICE
              //       ? pricingTemplateMappings.OFFER_PRICE
              //       : newChoose === pricingChoices.PREBOOK_PRICE
              //       ? pricingTemplateMappings.PREBOOK_PRICE
              //       : newChoose === pricingChoices.COMBI
              //       ? pricingTemplateMappings.COMBINED_PRICE
              //       : 'vs_price';

              //   if (newChoose !== pricingChoices.VSP) {
              //     const field = getDatesField(newChoose);
              //     const dateErr = validateDate(current[field]);
              //     setFieldError(current.objectId, field, dateErr);
              //   }

              //   const priceErr = validatePrice(
              //     current[priceKey],
              //     current.mrp,
              //     priceKey
              //   );
              //   setFieldError(current.objectId, priceKey, priceErr);
              // }, 0);
            }}
            dropdownBackgroundColor={'light'}
            value={cell}
            options={arrayToDropdownOptions(options)}
            placeholder={'Select option'}
            width={'100px'}
            menuPortalTarget={document.body}
          />
          {errors[row?.objectId]?.['choose'] && (
            <div
              className="text-danger"
              style={{ textWrap: 'auto', margin: 'auto' }}
            >
              {errors[row?.objectId]?.['choose']}
            </div>
          )}
        </div>
      );
    },
  },
  // {
  //   dataField: pricingTemplateMappings.IS_PREBOOK_PRODUCT,
  //   text: 'Is Prebook',
  //   formatter: (cell, row) => {
  //     if (row.choose !== pricingChoices.PREBOOK_PRICE) return '-';
  //     return (
  //       <>
  //         <EditableDropDown
  //           id={row?.objectId}
  //           onChange={(option) => {
  //             createRowChangeHandler(
  //               setProducts,
  //               setCopyData,
  //               pricingTemplateMappings.IS_PREBOOK_PRODUCT
  //             )(row, option?.value);
  //           }}
  //           dropdownBackgroundColor={'light'}
  //           value={cell}
  //           options={arrayToDropdownOptions(['0', '1'])}
  //           placeholder={'Select option'}
  //           menuPortalTarget={document.body}
  //         />
  //       </>
  //     );
  //   },
  // },
  {
    dataField: pricingTemplateMappings.IS_PREBOOK_PARTIAL_PAYMENT,
    text: 'Is Partial Payment',
    formatter: (cell, row) => {
      if (row.choose !== pricingChoices.PREBOOK_PRICE) return '-';
      return (
        <>
          <EditableDropDown
            id={row?.objectId}
            onChange={(option) => {
              setFieldError(
                row?.objectId,
                pricingTemplateMappings.IS_PREBOOK_PARTIAL_PAYMENT,
                ''
              );
              const isFullPayment = option.value === '0';
              if (isFullPayment) {
                createRowChangeHandler(
                  setProducts,
                  setCopyData,
                  pricingTemplateMappings.PREBOOK_PRICE
                )(row, row.vsp);
                createRowChangeHandler(
                  setProducts,
                  setCopyData,
                  pricingTemplateMappings.IS_PREBOOK_PRODUCT
                )(row, '1');
              }
              createRowChangeHandler(
                setProducts,
                setCopyData,
                pricingTemplateMappings.IS_PREBOOK_PARTIAL_PAYMENT
              )(row, option?.value);
              createRowChangeHandler(
                setProducts,
                setCopyData,
                pricingTemplateMappings.IS_PREBOOK_PRODUCT
              )(row, '1');
            }}
            dropdownBackgroundColor={'light'}
            value={cell}
            options={arrayToDropdownOptions(['0', '1'])}
            placeholder={'Select option'}
            menuPortalTarget={document.body}
          />
          {errors[row?.objectId]?.['is_prebook_partial_payment'] && (
            <div
              className="text-danger"
              style={{ textWrap: 'auto', margin: 'auto' }}
            >
              {errors[row?.objectId]?.['is_prebook_partial_payment']}
            </div>
          )}
        </>
      );
    },
  },
  {
    dataField: pricingTemplateMappings.PREBOOK_PRICE,
    text: 'Prebook Price',
    formatter: (cell, row) => {
      if (row.choose !== pricingChoices?.PREBOOK_PRICE) return '-';
      const isFullPayment = row?.is_prebook_partial_payment === '0';
      return (
        <div style={{ width: '9em' }}>
          <Form.Control
            type="number"
            placeholder="Enter Prebook Price"
            value={cell || ''}
            id={`prebook-price-${row?.objectId}`}
            onChange={(e) => {
              const value = e.target.value;
              const isFullPayment = row?.is_prebook_partial_payment === '0';
              const errorMsg = validatePrebookPrice(
                value,
                Number(row?.mrp)
                // isFullPayment
              );
              setFieldError(
                row.objectId,
                pricingTemplateMappings.PREBOOK_PRICE,
                errorMsg
              );

              createRowChangeHandler(
                setProducts,
                setCopyData,
                pricingTemplateMappings.PREBOOK_PRICE
              )(row, value);
            }}
            onFocus={() => setFocusRowId(row?.objectId)}
            autoFocus={focusRowId === row?.objectId}
          />
          {errors[row?.objectId]?.[pricingTemplateMappings.PREBOOK_PRICE] && (
            <div
              className="text-danger"
              style={{ textWrap: 'auto', margin: 'auto' }}
            >
              {errors[row?.objectId]?.[pricingTemplateMappings.PREBOOK_PRICE]}
            </div>
          )}
        </div>
      );
    },
  },
  {
    dataField: 'prebookDates',
    text: 'Prebook Dates',
    formatter: (cell, row) => {
      if (row.choose !== pricingChoices.PREBOOK_PRICE) return '-';
      return (
        <div style={{ width: '15em' }}>
          <ScheduleFormatter
            cell={cell || {}}
            row={row}
            onUpdate={(value) => {
              // console.log('Updated schedule:', value);
              // const { startDateTime, endDateTime } = value || {};
              const err = validateDate(value);
              console.log('err', err);
              setFieldError(row.objectId, 'prebookDates', err);
              createRowChangeHandler(
                setProducts,
                setCopyData,
                'prebookDates'
              )(row, value);
            }}
          />
          {errors[row?.objectId]?.prebookDates && (
            <div
              className="text-danger"
              style={{ textWrap: 'auto', margin: 'auto' }}
            >
              {errors[row?.objectId]?.prebookDates}
            </div>
          )}
        </div>
      );
    },
  },
  {
    dataField: 'vs_price',
    text: 'vs_price',
    formatter: (cell, row) => {
      const defaultValue = Number(row?.vsp) || '';
      // if (cell === undefined || cell === null || cell === '') {
      //   createRowChangeHandler(
      //     setProducts,
      //     setCopyData,
      //     'vs_price'
      //   )(row, Number(defaultValue));
      // }
      return (
        <div style={{ width: '9em' }}>
          <Form.Control
            type="number"
            placeholder="Enter vs Price"
            value={cell || ''}
            id={`vs-price-${row?.objectId}`}
            onChange={(e) => {
              const value = e.target.value;
              const errorMsg = validateVsPrice(value, Number(row?.mrp));
              setFieldError(row.objectId, 'vs_price', errorMsg);
              createRowChangeHandler(
                setProducts,
                setCopyData,
                'vs_price'
              )(row, value);
            }}
            onFocus={() => setFocusRowId(row?.objectId)}
            autoFocus={focusRowId === row?.objectId}
            // width={'20em'}
          />
          {errors[row?.objectId]?.vs_price && (
            <div
              className="text-danger"
              style={{ textWrap: 'auto', margin: 'auto' }}
            >
              {errors[row?.objectId]?.vs_price}
            </div>
          )}
        </div>
      );
    },
  },
  {
    dataField: pricingTemplateMappings.OFFER_PRICE,
    text: 'Offer Price',
    formatter: (cell, row) => {
      if (row?.choose !== pricingChoices?.OFFER_PRICE) return '-';
      return (
        <div style={{ width: '9em' }}>
          <Form.Control
            type="number"
            placeholder="Enter Offer Price"
            value={cell || ''}
            id={`offer-price-${row?.objectId}`}
            onChange={(e) => {
              const value = e.target.value;
              const err = validatePrice(value, row.mrp, 'Offer Price');
              setFieldError(
                row.objectId,
                pricingTemplateMappings?.OFFER_PRICE,
                err
              );
              createRowChangeHandler(
                setProducts,
                setCopyData,
                pricingTemplateMappings?.OFFER_PRICE
              )(row, value);
            }}
            onFocus={() => setFocusRowId(row?.objectId)}
            autoFocus={focusRowId === row?.objectId}
          />
          {errors[row?.objectId]?.[pricingTemplateMappings.OFFER_PRICE] && (
            <div
              className="text-danger"
              style={{ textWrap: 'auto', margin: 'auto' }}
            >
              {errors[row?.objectId]?.[pricingTemplateMappings.OFFER_PRICE]}
            </div>
          )}
        </div>
      );
    },
  },
  {
    dataField: 'offerPriceDates',
    text: 'Offer Price Dates',
    formatter: (cell, row) => {
      if (row?.choose !== pricingChoices?.OFFER_PRICE) return '-';
      return (
        <div style={{ width: '15em' }}>
          <ScheduleFormatter
            row={row}
            cell={cell || {}}
            onUpdate={(newSchedule) => {
              // const { startDateTime, endDateTime } = newSchedule || {};
              const err = validateDate(newSchedule);
              setFieldError(row.objectId, 'offerPriceDates', err);
              createRowChangeHandler(
                setProducts,
                setCopyData,
                'offerPriceDates'
              )(row, newSchedule);
            }}
          />
          {errors[row?.objectId]?.offerPriceDates && (
            <div
              className="text-danger"
              style={{ textWrap: 'auto', margin: 'auto' }}
            >
              {errors[row?.objectId]?.offerPriceDates}
            </div>
          )}
        </div>
      );
    },
  },
  {
    dataField: pricingTemplateMappings.COMBINED_PRICE,
    text: pricingTemplateMappings.COMBINED_PRICE,
    formatter: (cell, row) => {
      if (row?.choose !== pricingChoices?.COMBI) return '-';
      return (
        <div style={{ width: '9em' }}>
          <Form.Control
            type="number"
            placeholder="Enter price"
            value={cell || ''}
            id={`combi-price5-${row?.objectId}`}
            onChange={(e) => {
              const value = e.target.value;
              const err = validatePrice(value, row.mrp, 'Combi Price');
              setFieldError(
                row.objectId,
                pricingTemplateMappings.COMBINED_PRICE,
                err
              );
              createRowChangeHandler(
                setProducts,
                setCopyData,
                pricingTemplateMappings.COMBINED_PRICE
              )(row, value);
            }}
            onFocus={() => setFocusRowId(row?.objectId)}
            autoFocus={focusRowId === row?.objectId}
          />
          {errors[row?.objectId]?.[pricingTemplateMappings.COMBINED_PRICE] && (
            <div
              className="text-danger"
              style={{ textWrap: 'auto', margin: 'auto' }}
            >
              {errors[row?.objectId]?.[pricingTemplateMappings.COMBINED_PRICE]}
            </div>
          )}
        </div>
      );
    },
  },
  {
    dataField: 'combiDates',
    text: 'combi dates',
    formatter: (cell, row) => {
      if (row?.choose !== pricingChoices?.COMBI) return '-';
      return (
        <div style={{ width: '15em' }}>
          <ScheduleFormatter
            row={row}
            cell={cell || {}}
            onUpdate={(newSchedule) => {
              // const { startDateTime, endDateTime } = newSchedule || {};
              const err = validateDate(newSchedule);
              setFieldError(row.objectId, 'combiDates', err);
              createRowChangeHandler(
                setProducts,
                setCopyData,
                'combiDates'
              )(row, newSchedule);
            }}
          />
          {errors[row?.objectId]?.combiDates && (
            <div
              className="text-danger"
              style={{ textWrap: 'auto', margin: 'auto' }}
            >
              {errors[row?.objectId]?.combiDates}
            </div>
          )}
        </div>
      );
    },
  },
  {
    dataField: 'requestedReason',
    text: 'Price Change Reason',
    formatter: (cell, row) => {
      const options = [
        'Price Match Competitor',
        'Seasonal Discount',
        'Promotional Offer',
        'Market Change',
      ];
      const selectedOption = cell ? { label: cell, value: cell } : null;

      return (
        <Creatable
          value={selectedOption}
          onChange={(option) => {
            createRowChangeHandler(
              setProducts,
              setCopyData,
              'requestedReason'
            )(row, option?.value);
          }}
          options={arrayToDropdownOptions(options)}
          placeholder="Select Or Type the Reason"
          menuPortalTarget={document.body}
        />
      );
    },
  },
  {
    dataField: 'delete',
    text: 'Delete',
    formatter: (cell, row) => (
      <Button
        onClick={(e) => {
          e.stopPropagation();
          handleXClick(row?.objectId, row?.vanNo);
        }}
        className="d-flex justify-content-center align-content-center"
        style={{
          height: '100%',
          margin: '0',
          padding: '0',
          borderColor: 'white',
          backgroundColor: 'transparent',
        }}
      >
        <FontAwesomeIcon icon={faXmark} size="xl" color="black" />
      </Button>
    ),
  },
];

/**
 * Parse a cron expression and schedule data into a simplified format
 * @param {Object} scheduleData - The schedule data object
 * @param {string} scheduleData.cronExpression - The cron expression string
 * @param {string} scheduleData.startDate - Optional start date (YYYY-MM-DD format)
 * @param {string} scheduleData.endDate - Optional end date (YYYY-MM-DD format)
 * @returns {Object} Parsed schedule information
 */
const parseSchedule = (scheduleData) => {
  if (!scheduleData || !scheduleData.cronExpression) {
    return { error: 'No valid schedule data provided' };
  }

  const { cronExpression, startDate, endDate } = scheduleData;

  // Split cron expression into components
  const [minutes, hours, dayOfMonth, month, dayOfWeek] =
    cronExpression.split(' ');

  // Parse scheduling data
  const result = {
    // Original data
    originalCron: cronExpression,

    // Time information
    time: parseTimeInfo(minutes, hours),

    // Day information
    days: parseDaysInfo(dayOfWeek),

    // Date range if provided
    dateRange: parseDateRange(startDate, endDate),

    // Simple text explanation
    summary: '',
  };

  // Generate human-readable summary
  result.summary = generateSummary(result);

  return result;
};

/**
 * Parse time information from cron expression
 */
const parseTimeInfo = (minutes, hours) => {
  const timeInfo = {
    minutes: minutes,
    pattern: '',
  };

  // Check for time pattern
  if (hours === '*') {
    timeInfo.pattern = 'everyHour';
  } else if (hours.includes('-')) {
    timeInfo.pattern = 'timeRange';
    const [start, end] = hours.split('-');

    timeInfo.startHour = parseInt(start);
    timeInfo.endHour = parseInt(end);
    timeInfo.formattedStart = formatTime(start, minutes);
    timeInfo.formattedEnd = formatTime(end, minutes);
  } else {
    timeInfo.pattern = 'specificTime';
    timeInfo.hour = parseInt(hours);
    timeInfo.formattedTime = formatTime(hours, minutes);
  }

  return timeInfo;
};

/**
 * Parse days information from cron expression
 */
const parseDaysInfo = (dayOfWeek) => {
  const daysInfo = {
    pattern: '',
  };

  if (dayOfWeek === '*') {
    daysInfo.pattern = 'everyDay';
    return daysInfo;
  }

  // Day names (where 0 is Sunday)
  const dayNames = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];
  let daysList = [];

  // Handle comma-separated list like 1,3,5
  if (dayOfWeek.includes(',')) {
    daysList = dayOfWeek.split(',').map((day) => parseInt(day));
  }
  // Handle range like 1-5
  else if (dayOfWeek.includes('-')) {
    const [start, end] = dayOfWeek.split('-').map((day) => parseInt(day));
    for (let i = start; i <= end; i++) {
      daysList.push(i);
    }
  }
  // Handle single day
  else {
    daysList = [parseInt(dayOfWeek)];
  }

  // Determine if it's weekdays, weekends, or specific days
  if (
    daysList.length === 5 &&
    [1, 2, 3, 4, 5].every((day) => daysList.includes(day))
  ) {
    daysInfo.pattern = 'weekdays';
  } else if (
    daysList.length === 2 &&
    daysList.includes(0) &&
    daysList.includes(6)
  ) {
    daysInfo.pattern = 'weekends';
  } else {
    daysInfo.pattern = 'specificDays';
  }

  daysInfo.days = daysList;
  daysInfo.dayNames = daysList.map((day) => dayNames[day % 7]);

  return daysInfo;
};

/**
 * Parse date range information
 */
const parseDateRange = (startDate, endDate) => {
  const dateRange = {};

  if (startDate) {
    dateRange.startDate = startDate;
    dateRange.formattedStartDate = formatDate(startDate);
  }

  if (endDate) {
    dateRange.endDate = endDate;
    dateRange.formattedEndDate = formatDate(endDate);
  }

  return dateRange;
};

/**
 * Format time in 12-hour format
 */
const formatTime = (hour, minutes) => {
  hour = parseInt(hour);
  const min = minutes === '0' ? '00' : minutes;
  const period = hour >= 12 ? 'PM' : 'AM';
  const displayHour = hour > 12 ? hour - 12 : hour === 0 ? 12 : hour;

  return `${displayHour}:${min} ${period}`;
};

/**
 * Format date
 */
const formatDate = (dateStr) => {
  if (!dateStr) return '';

  const date = new Date(dateStr);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

/**
 * Generate a human-readable summary of the schedule
 */
const generateSummary = (scheduleData) => {
  let summary = '';

  // Add time information
  const { time, days, dateRange } = scheduleData;

  if (time.pattern === 'everyHour') {
    summary += 'Every hour';
    if (time.minutes !== '0') {
      summary += ` at ${time.minutes} minutes past the hour`;
    }
  } else if (time.pattern === 'timeRange') {
    summary += `From ${time.formattedStart} to ${time.formattedEnd}`;
  } else if (time.pattern === 'specificTime') {
    summary += `At ${time.formattedTime}`;
  }

  // Add day information
  if (days.pattern === 'everyDay') {
    summary += ' every day';
  } else if (days.pattern === 'weekdays') {
    summary += ' on weekdays';
  } else if (days.pattern === 'weekends') {
    summary += ' on weekends';
  } else if (days.pattern === 'specificDays') {
    summary += ` on ${days.dayNames.join(', ')}`;
  }

  // Add date range if provided
  if (dateRange.startDate && dateRange.endDate) {
    summary += ` from ${dateRange.formattedStartDate} until ${dateRange.formattedEndDate}`;
  } else if (dateRange.startDate) {
    summary += ` starting from ${dateRange.formattedStartDate}`;
  } else if (dateRange.endDate) {
    summary += ` until ${dateRange.formattedEndDate}`;
  }

  return summary;
};

export { parseSchedule };

/**
 * Excel serial → IST scheduler object
 * Keeps the exact 24-hour time that is already encoded in the serial
 */
export function buildSchedulerObject(startDateNum, endDateNum) {
  const excelEpoch = new Date(1899, 11, 30); // Excel base (UTC)
  const msPerDay = 86400000;

  // build UTC Date objects
  const startDt = new Date(excelEpoch.getTime() + startDateNum * msPerDay);
  const endDt = new Date(excelEpoch.getTime() + endDateNum * msPerDay);

  // extract raw hours & minutes (24-hour) from the fractional part
  const startMinutes = Math.round((startDateNum % 1) * 24 * 60);
  const endMinutes = Math.round((endDateNum % 1) * 24 * 60);

  const startH = String(Math.floor(startMinutes / 60)).padStart(2, '0');
  const startM = String(startMinutes % 60).padStart(2, '0');
  const endH = String(Math.floor(endMinutes / 60)).padStart(2, '0');
  const endM = String(endMinutes % 60).padStart(2, '0');

  const startHHMM = `${startH}:${startM}`;
  const endHHMM = `${endH}:${endM}`;

  // date part in YYYY-MM-DD, IST midnight
  const startD = new Date(
    excelEpoch.getTime() + Math.floor(startDateNum) * msPerDay
  );
  const endD = new Date(
    excelEpoch.getTime() + Math.floor(endDateNum) * msPerDay
  );

  const startDate = startD.toLocaleDateString('sv-SE', {
    timeZone: 'Asia/Kolkata',
  });
  const endDate = endD.toLocaleDateString('sv-SE', {
    timeZone: 'Asia/Kolkata',
  });

  const startISO = `${startDate}T${startHHMM}`;
  const endISO = `${endDate}T${endHHMM}`;

  return {
    desc: `Runs from ${startHHMM} to ${endHHMM} every day - from ${startDate} ${startHHMM} until ${endDate} ${endHHMM}`,
    cronExpression: `0 ${startHHMM}-${endHHMM} * * *`,
    startDateTime: startISO,
    endDateTime: endISO,
    specificStartTime: startHHMM,
    specificEndTime: endHHMM,
  };
}

// helpers at top of file (or utils)
export const required = (val) => (val === '' || val == null ? 'Required' : '');

export const validatePrice = (price, mrp, label) => {
  const base = required(price);
  if (base) return base;
  if (Number(price) > Number(mrp)) return `${label} cannot exceed MRP`;
  return '';
};

export const validateDate = (schedule) => {
  if (!schedule?.startDateTime || !schedule?.endDateTime)
    return 'Start & End dates are required';
  if (schedule.startDateTime < todayISO()) return 'Start date cannot be past';
  if (schedule.endDateTime && schedule.startDateTime >= schedule.endDateTime)
    return 'Start must be before End';
  return '';
};

const todayISO = () => {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d.toISOString().slice(0, 16); // yyyy-mm-ddThh:mm
};

// export const validateDate = (start /* ISO string */, end /* ISO string */) => {
//   if (!start) return 'Start date is required';
//   if (start < todayISO()) return 'Start date cannot be in the past';
//   if (end && start >= end) return 'Start date must be before end date';
//   return '';
// };

// export const validatePrice = (price, mrp, field) => {
//   if (price === '' || price === undefined || price === null)
//     return `${field} is required`;
//   if (Number(price) > Number(mrp)) return `${field} cannot exceed MRP`;
//   return '';
// };
